import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetHarmfulFactorDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { Selector, Option } from '../Selects/Selector';

interface HarmfulFactorSelectorProps {
  value?: string;
  onChange?: (option: Option) => void;
  readOnly?: boolean;
  clearable?: boolean;
}

export default (props: HarmfulFactorSelectorProps) => {
  const spd = useSpdCore();
  const [harmfulFactors, setHarmfulFactors] = useState<GetHarmfulFactorDto[]>(
    [],
  );
  const [displayName, setDisplayName] = useState<string>();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    spd.harmfulFactors
      .getAll()
      .then(all => {
        if (mounted) {
          setHarmfulFactors(
            all.sort((a, b) => (a.name || '').localeCompare(b.name || '')),
          );
          setReady(true);
        }
      })
      .catch(error =>
        console.log(
          `Wystąpił problem z pobraniem czynników szkodliwych. ${error}`,
        ),
      );
    return () => {
      mounted = false;
    };
  }, [spd.harmfulFactors]);

  useEffect(() => {
    if (props.value) {
      const found = harmfulFactors.find(f => f.id === props.value);
      setDisplayName(found?.name || '');
    } else {
      setDisplayName('');
    }
  }, [props.value, harmfulFactors]);

  const provider = async (text: string): Promise<Option[]> =>
    harmfulFactors
      .filter(f => (f.name || '').toLowerCase().includes(text.toLowerCase()))
      .map(f => ({ value: f.id, label: f.name || '' }));

  return ready ? (
    <Selector
      uniqueKey={'harmful-factor-' + JSON.stringify(harmfulFactors)}
      readOnly={props.readOnly}
      creatable={false}
      placeholder="Wskaż..."
      provider={provider}
      value={displayName}
      onChange={props.onChange}
      clearable={props.clearable}
    />
  ) : (
    <Skeleton />
  );
};
